export default __webpack_public_path__ + "static/partnerColorIcon10-c774bed740dac510978914e66a0c1fd1.svg";